import PredefinedDataSelect from 'components/inputs/predefined-data-select/PredefinedDataSelect';
import { IFormInputSpecFaultType } from 'pages/revisions-module/template-editor/editors/form/types';
import { useTemplateEditorData } from 'pages/revisions-module/template-editor/TemplateEditorDataProvider';

/**
 * Preview for a text input.
 */
export default function FaultTypeInputPreview({ spec }: { spec: IFormInputSpecFaultType }) {
  const { deviceType } = useTemplateEditorData();

  return (
    <PredefinedDataSelect
      revisionId={0}
      predefinedDataType="Nedostatky"
      deviceTypeId={deviceType.id}
      required={spec.required}
      readOnly={spec.readOnly}
      size="sm"
    />
  );
}
